import { Controller, useFormContext } from 'react-hook-form';
import { Radio, RadioGroup } from '@ds';
import { DONOR_TYPES } from '@features/components/CaseFormBlocks/config';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { memo, useCallback } from 'react';
import { FormRow } from '@features/components/CaseFormBlocks/components';
import { DonorType } from '@/api/apis/case';

type DonorTypeSelectorProps = {
  disabled?: boolean;
  isRequired?: boolean;
  hasPermission?: boolean;
};

export const DonorTypeSelector = memo(({ disabled, isRequired, hasPermission }: DonorTypeSelectorProps) => {
  const { setValue, trigger, control } = useFormContext<CaseFormType>();

  const handleDonorChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const donor = e.target.value as DonorType;
      setValue('donorType', donor);
      setValue('reAllocationCaseId', null);
      trigger('reAllocationCase');
    },
    [setValue, trigger],
  );

  return (
    <FormRow title="Donor Type" isRequired={isRequired}>
      <Controller
        name="donorType"
        control={control}
        render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
          <RadioGroup
            isDisabled={disabled || !hasPermission}
            className="gap-8"
            orientation="horizontal"
            value={value || ''}
            isInvalid={invalid}
            errorMessage={error?.message}
            onChange={handleDonorChange}
            {...field}
          >
            {DONOR_TYPES.map((donorType) => (
              <Radio key={donorType.value} className="w-[100px] max-w-none" value={donorType.value as string} size="lg">
                {donorType.name}
              </Radio>
            ))}
          </RadioGroup>
        )}
      />
    </FormRow>
  );
});
